import { render } from "./NeurologicalDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=template&id=4fc92df3&scoped=true"
import script from "./NeurologicalDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"

import "./NeurologicalDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=style&index=0&id=4fc92df3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc92df3"]])

export default __exports__